import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiCreateContract, type CreateContractInput } from '../api/contracts.api';

export function useCreateContract(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (input: CreateContractInput) => apiCreateContract(projectId, input),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['paymentContracts', projectId] });
            qc.invalidateQueries({ queryKey: ['paymentMilestones', projectId] });
        },
    });
}
